import { sitemap } from 'app/shared/util/url-utils';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  useGetCurrentUserProfileQuery,
  useUpdateCurrentUserProfileMutation,
} from 'app/store/reducers/api/config-manager-cloud-services/store/user-profiles';
import { useGetCurrentAccountProfileQuery } from 'app/store/reducers/api/config-manager-cloud-services/store/account-profiles';
import { UserRead } from 'app/store/reducers/api/config-manager-cloud-services/store/types';
import { skipToken } from '@reduxjs/toolkit/query/react';
import { useGetCurrentBillingProfileQuery } from 'app/store/reducers/api/config-manager-cloud-services/store/billing-profile';
import { setCurrentAccountId } from 'app/shared/api/accountContext';

export const useFetchUserAccounts = () => {
  const navigate = useNavigate();

  const { data: userProfile = {} as UserRead, isError: isUserProfileError } = useGetCurrentUserProfileQuery();
  useGetCurrentAccountProfileQuery(userProfile.id ? undefined : skipToken);
  useGetCurrentBillingProfileQuery(userProfile.id ? undefined : skipToken);
  const [updateUserProfile] = useUpdateCurrentUserProfileMutation();
  // const [createNewAccount] = useCreateAccountMutation();

  // wrap in useEffect to avoid bad setState() call : error Cannot update a component ... while rendering a different component ...
  // useEffect(() => {
  //   if (isUserProfileError) {
  //     navigate(sitemap.error, { state: { message: 'Failed to fetech user profile' } });
  //   } else if (isCurrentAccountProfileError) {
  //     navigate(sitemap.error, { state: { message: 'Failed to fetech current account profile' } });
  //   }
  // }, [isUserProfileError, isCurrentAccountProfileError]);

  useEffect(() => {
    if (!userProfile.currentAccount && userProfile.accounts) {
      if (userProfile.accounts.length > 0) {
        updateUserProfile({ updates: { currentAccount: userProfile.accounts[0].accountId } }).unwrap();
      }
      // else {
      //   createNewAccount();
      // }
    }
  }, [userProfile]);

  useEffect(() => {
    setCurrentAccountId(userProfile.currentAccount ?? null);
  }, [userProfile.currentAccount]);
};
